import {emptyArray, emptyArray_forLoading} from "js-vextensions";
import {CreateAccessor, GetDoc, GetDocs} from "mobx-graphlink";
import {CommandRun} from "./commandRuns/@CommandRun.js";
import {MeID} from "./users.js";

export const GetCommandRuns = CreateAccessor((commandTypes?: string[], actorID?: string, showAll?: boolean)=>{
	// temp; when user-info not yet loaded, don't make db-request for command-runs table
	//		(it has RLS policies that give incomplete results if caller's user-id is null, and currently mobx-graphlink doesn't know how/when to refresh this once user-info is available)
	//if (MeID() == null) return emptyArray_forLoading;

	return GetDocs({
		//queryOps: [new WhereOp("name", "==", name)],
		params: {filter: {
			commandName: commandTypes && {in: commandTypes},
			actor: actorID && {equalTo: actorID},
			public_base: !showAll && {equalTo: true},
		}},
	}, a=>a.commandRuns);
});

export const GetManyCommandRuns = CreateAccessor((commandIds?: string[])=>{
	return GetDocs({
		params: {filter: {
			id: {in: commandIds},
		}},
	}, a=>a.commandRuns);
});

export const GetCommandRun = CreateAccessor((id: string|n)=>{
	return GetDoc({}, a=>a.commandRuns.get(id!));
});